<template>
  <MainWrapper>
    <div class="companies-control-panel mb-30">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="companies-control-panel-inner">
              <router-link to="/user/companies" class="mr-20 header-link">
                <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'user-circle']" />
                <span class="dark-body-text panel-body-text">Мои компании</span>
              </router-link>
              <!--
                        <router-link to="" class="mr-20">
                            <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'user-circle']" />
                            <span class="dark-body-text panel-body-text"></span>
                        </router-link>
              -->
              <router-link
                v-if="company.id !== 999999999"
                :to="`/companies/${$route.params.slug}/invite-specialist`"
                class="mr-20 header-link"
              >
                <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'user-circle']" />
                <span class="dark-body-text panel-body-text">Пригласить специалиста</span>
              </router-link>
              <router-link
                v-if="company.id !== 999999999"
                :to="`/companies/${$route.params.slug}/settings`"
                class="mr-20 pointer header-link"
              >
                <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'cog']" />
                <span class="dark-body-text panel-body-text">Настройки</span>
              </router-link>
              <router-link
                v-if="company.id !== 999999999"
                :to="`/companies/${$route.params.slug}/reservations`"
                class="mr-20 header-link"
              >
                <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'calendar-check']" />
                <span class="dark-body-text panel-body-text">Все записи</span>
              </router-link>
              <div v-if="company.id !== 999999999" class="pointer pull-right">
                <router-link :to="`/companies/${$route.params.slug}/add-specialist`">
                  <span class="dark-body-text panel-body-text">Добавить</span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="single-master-page">
      <div class="container">
        <div class="row" v-if="company.status === 'moderating'">
          <div class="col-lg-12">
            <holder
              class="mt-40"
              title="Ваша компания на модерации"
              icon="pencil-alt"
              :desc="`'${company.name}' всё ещё находится на модерации. Модерация занимает в среднем от 2-х часов до 2-х дней. В итоге, мы вас уведомим по email / номеру телефона. Спасибо большое!`"
            />
          </div>
        </div>
        <div class="row" v-else>
          <h3 class="black-text text-center mb-15">Поиск специалиста</h3>
          <div class="mb-30 text-center">
            <div class="spec-search-wrapper inline-block">
              <font-awesome-icon class="spec-search-icon" :icon="['far', 'search']" />
              <input
                class="rounded-input spec-search"
                v-model="search"
                @change="this.getSpecialists"
                @input="checkSearch"
                placeholder="Поиск специалиста"
              />
            </div>
          </div>
        </div>
        <div class="row" v-if="!specialists.length && search.length">
          <div class="col-lg-12">
            <holder
              title="Специалистов не найдено!"
              icon="folder-open"
              desc="В вашей компании ещё нет специалиста с таким именем. Для того чтобы его добавить, пожалуйста, нажмите 'добавить специалиста'"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="container-fluid no-p">
              <div class="row">
                <div class="col-lg-12">
                  <div class="mb-30">
                    <Paginator
                      :pages="pages"
                      v-if="pages > 1"
                      :current="page"
                      v-on:change-page="(p) => page = p"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12" v-for="spec in specialists" :key="spec.id">
                  <router-link :to="'/masters/'+spec.slug">
                    <div
                      class="animated-shadow pt-15 pr-15 pb-15 pl-15 mb-10 specialists"
                      style="background: #ffffff;border-radius: 4px;"
                    >
                      <div class="flx-7" style="display: inline-block ">
                        <div
                          v-if="spec.photo"
                          class="spec-img"
                          :style="{'background-image': `url(${spec.photo})`}"
                        ></div>
                        <div v-else class="spec-img">
                          <h3 style="text-transform:uppercase">{{ spec.full_name[0] }}</h3>
                        </div>
                      </div>
                      <div class="flx-40" style="display: inline-block">
                        <div>ФИО</div>
                        <div class="dark-body-text">{{ spec.full_name }}</div>
                      </div>
                      <div class="flx-20" style="display: inline-block">
                        <div>Специальность</div>
                        <div class="dark-body-text">{{ spec.categories[0] }}</div>
                      </div>
                      <div class="flx-10" style="display: inline-block">
                        <div>Телефон</div>
                        <div class="dark-body-text">&nbsp;</div>
                      </div>
                      <div class="flx-10" style="display: inline-block">
                        <div>E-mail</div>
                        <div class="dark-body-text">&nbsp;</div>
                      </div>
                      <div
                        v-if="inOrg(spec.company) === false"
                        style="display: inline-block"
                        class="flx-10"
                      >
                        <router-link to>
                          <Button
                            type="gray"
                            text="Пригласить"
                            @click="inviteForm = true; inviteId = spec.id; inviteName = spec.full_name"
                          />
                        </router-link>
                      </div>
                    </div>
                  </router-link>
                  <!--Specialist :name="spec.full_name"
                                            :rating="spec.rating"
                                            :cats="spec.categories"
                                            :desc="spec.short_info"
                                            :state="false"
                                            :address="'г. Бишкек'"
                                            :img="spec.photo_url"
                                            :slug="spec.slug"
                                            :admin="true"
                                            :admin-company="company.slug"
                  /-->
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <Paginator
                    :pages="pages"
                    v-if="pages > 1"
                    :current="page"
                    v-on:change-page="(p) => page = p"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="inviteForm == true"
        style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:99999"
      >
        <div
          style="position:absolute;width:320px;height:200px;top:50%;left:50%;background:#ffffff;margin:-100px 0 0 -160px;padding:20px;box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.07);border-radius: 4px;"
        >
          <h3 class="mb-10">Приглашение специалиста</h3>
          <p class="mt-20 mb-20">
            Вы хотите добавить в компанию
            <br />
            <strong>{{ inviteName }}</strong>
            <br />подтвердите или отмените действие
          </p>
          <div>
            <div class="mr-10 inline-block">
              <Button type="blue" text="Подтвердить" @click="updateOrder" />
            </div>
            <div class="inline-block">
              <Button
                type="gray"
                text="Отмена"
                @click="inviteForm = false; inviteId = ''; inviteName = ''"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </MainWrapper>
</template>
<style lang="stylus" scoped>
@import '../../styles/main.core.vars.styl';

.spec-categories {
  padding: 20px 60px 30px 20px;
}

.spec-categories-header {
  display: flex;

  .spec-count {
    margin: 0 0 0 auto;
    color: $gray_text;
  }
}

.spec-categories-single {
  display: flex;
  align-items: center;

  >.icon {
    margin-left: auto;
    font-size: 16px;
  }
}

.companies-control-panel {
  margin-top: -30px;
  height: 56px;
  background: $black_text;

  .panel-body-text, .panel-icon {
    color: #fff;
  }

  &-inner {
    height: 56px;
    display: flex;
    align-items: center;
  }

  input {
    width: 430px;
  }
}

.col-lg-1 {
  min-height: 0;
}

.arr-down {
  position: absolute;
  bottom: -2px;
  width: 0;
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 9px solid $black_text;
  z-index: 4;
  left: 0;
  right: 0;
  margin: auto;
}

.spec-search-icon {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  left: 15px;
  color: $dark_gray_text;
}

.spec-search {
  width: 420px;
  padding: 9px 15px 10px 40px;
}

.spec-search-wrapper {
  position: relative;
}

.spec-img {
  width: 50px;
  height: 50px;
  border-radius: 100%;
  background: cyan_dark_color;
  /* margin-left: 5px */
  background-size: cover;
  background-position: center;
  /* display: flex */
  align-items: center;
  justify-content: center;

  h3 {
    color: #fff;
    margin: 0;
    font-size: 36px;
    text-align: center;
    line-height: 48px;
  }
}

.specialists {
  display: flex;
}
</style>
<script>
import { Component, Vue, Watch } from "vue-property-decorator";
import MainWrapper from "@/wrappers/MainWrapper.vue";
import Button from "@/components/Button.vue";
import Specialist from "@/components/Specialist.vue";
import Paginator from "@/components/Paginator.vue";
import Holder from "@/components/Holder.vue";

import http from "@/methods/http.ts";

@Component({
  components: {
    MainWrapper,
    Button,
    Specialist,
    Paginator,
    Holder
  }
})
export default class CompanyAdmin extends Vue {
  specialists = [];
  company = {};

  categories = [];
  childCategories = [];

  lvl1Scrolled = 0;
  lvl2Scrolled = 0;

  page = 1;
  pages = 0;
  search = "";

  inviteForm = false;
  inviteId = "";
  inviteName = "";

  @Watch("$route", { deep: true, immediate: true })
  onRouteChange() {
    this.page = 1;
    this.getSpecialists();
  }

  @Watch("page", { deep: true, immediate: true })
  onPageChange() {
    this.getSpecialists();
  }

  checkSearch() {
    if (this.search !== "") {
      this.getSpecialists();
    }
  }

  getSpecialists() {
    http("masters", "get", false, {
      page: this.page,
      page_size: 12,
      search: this.search
      //categories: this.chosenChildCategory || this.chosenCategory || undefined,
    }).then(r => {
      this.specialists = r.data.results;
      this.pages = Math.ceil(r.data.count / 10);
      this.specCount = r.data.count;
    });
  }

  getCompany() {
    http(`companies/${this.$route.params.slug}`, "get", false, {}).then(r => {
      this.company = r.data;
      this.getSpecialists();
    });
  }

  inOrg(orgs) {
    let output = false;
    if (orgs !== null) {
      let org_id = this.company.id;
      orgs.forEach(function(elm) {
        if (elm.id === org_id) {
          output = true;
        }
      });
    }
    return output;
  }

  created() {
    this.getCompany();
  }
}
</script>